import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  MapPinIcon,
  PhoneIcon,
  EnvelopeIcon,
  UserIcon,
} from "@heroicons/react/24/solid";
import { useTranslation } from "react-i18next";
import FormInput from "../../../components/controls/FormInput";
import FormTextarea from "../../../components/controls/FormTextArea";

const RepresentativePublicPage = () => {
  const { t } = useTranslation();
  const { codeRepresentant } = useParams();
  const [rep, setRep] = useState(null);
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const fetchRep = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/Representative/code/${codeRepresentant}`
      );
      if (response.ok) {
        const data = await response.json();
        setRep(data);
      }
    };
    fetchRep();
  }, [codeRepresentant]);

  const handleInputChange = (name, value) => {
    setForm({ ...form, [name]: value });
  };

  const handleContactSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/Representative/contact/${codeRepresentant}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(form), // contient name, email, message
        }
      );

      if (!res.ok) throw new Error("Erreur lors de l’envoi");

      const toast = document.getElementById("toast");
      toast.classList.remove("hidden");
      setSubmitted(true);
      setForm({ name: "", email: "", message: "" });
      setTimeout(() => {
        toast.classList.add("hidden");
      }, 3000);
    } catch (err) {
      console.error(err);
    }
  };

  if (!rep) return null;

  return (
    <div className="max-w-4xl mx-auto py-10 px-4 text-primary">
      <h1 className="text-3xl font-bold text-primary mb-4">
        Représentant : {rep.firstName} {rep.lastName}
      </h1>
      <div className="bg-white shadow rounded-lg p-6 mb-10">
        <h1 className="text-3xl font-bold text-papayaTitle mb-2">
          Informations du représentant
        </h1>

        <div className="space-y-3 mt-4 text-gray-700 text-base">
          {rep.city && (
            <div className="flex items-center">
              <MapPinIcon className="h-5 w-5 text-papayaTitle mr-2" />
              {rep.city}
            </div>
          )}

          {rep.phoneNumber && (
            <div className="flex items-center">
              <PhoneIcon className="h-5 w-5 text-papayaTitle mr-2" />
              {rep.phoneNumber}
            </div>
          )}

          {rep.email && (
            <div className="flex items-center">
              <EnvelopeIcon className="h-5 w-5 text-papayaTitle mr-2" />
              {rep.email}
            </div>
          )}
        </div>
      </div>

      <div className="bg-gray-50 shadow rounded-lg p-6">
        <h2 className="text-xl font-semibold mb-4 text-papayaTitle">
          {t("contactPage.title")}
        </h2>

        {submitted ? (
          <p className="text-green-600">{t("contactPage.messageSent")}</p>
        ) : (
          <form onSubmit={handleContactSubmit} className="space-y-4">
            <div className="space-y-4 mt-6">
              <FormInput
                name="name"
                label={t("auth.fullName")}
                value={form.name}
                onChange={(name, value) => handleInputChange(name, value)}
                placeholder={t("auth.fullNamePlaceholder")}
                required
              />

              <FormInput
                name="email"
                label={
                  t("global.yourEmail") + " / " + t("global.yourPhoneNumber")
                }
                value={form.email}
                onChange={(name, value) => handleInputChange(name, value)}
                placeholder={"Entrez votre email ou numéro de téléphone"}
                required
              />

              <div>
                <FormTextarea
                  label={t("contactPage.messageLabel")}
                  name="message"
                  value={form.message}
                  onChange={handleInputChange}
                  placeholder={t("contactPage.messagePlaceholder")}
                  className="w-full border rounded px-3 py-2"
                  rows={4}
                  required
                />
              </div>

              <button
                onClick={handleContactSubmit}
                className="block mt-4 bg-bgCyan text-white px-4 py-2 rounded-full hover:bg-hoverCyan transition mx-auto"
              >
                {t("contactPage.submitButton")}
              </button>
            </div>
          </form>
        )}
      </div>
      <div id="toast" className="toast toast-top toast-end hidden z-50">
        <div className="alert alert-success">
          <span>
            Votre message a été envoyé avec succès. Nous vous répondrons dès que
            possible.
          </span>
        </div>
      </div>
    </div>
  );
};

export default RepresentativePublicPage;
